import React from 'react';
import { FormControl, FormHelperText, MenuItem, Select as MuiSelect, Typography } from '@mui/material';

const Select = ({ options, name, label, errors, size, fullWidth, ...rest }) => {
    const optionsAreStrings = options?.[0]?.value == null; // Should we just enforce that options are an array of objects with value and label?
    return (
        <FormControl sx={{ my: 1 }} size={size} error={!!errors?.[name]} fullWidth={fullWidth}>
            <MuiSelect
                displayEmpty
                renderValue={(value) => {
                    if (!value) {
                        return <Typography sx={{ color: 'text.disabled' }}>Select {label}</Typography>;
                    }
                    const option = optionsAreStrings ? options.find((opt) => opt === value) : options.find(({ value: v }) => v === value)?.label;
                    return option;
                }}
                {...rest}
            >
                <MenuItem disabled value="">
                    Select {label}
                </MenuItem>
                {options.map((option) => {
                    let value = option;
                    let optionLabel = option;
                    if (!optionsAreStrings) {
                        value = option.value;
                        optionLabel = option.label;
                    }
                    return (
                        <MenuItem key={value} value={value}>
                            {optionLabel}
                        </MenuItem>
                    );
                })}
            </MuiSelect>
            {errors?.[name] && <FormHelperText>{errors?.[name].message}</FormHelperText>}
        </FormControl>
    );
};

export default Select;
